/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React from 'react';
import { useNavigationViews } from '@jira/polaris__component-navigation-store/src/useIsNavigationLocked.tsx';
import { useContainerId } from '../../controllers/context.tsx';
import type { NavigationContainer } from '../../common/types.tsx';
import { Views } from './views/index.tsx';

type MenuItemsProps = {
	navigationContainer: NavigationContainer;
	dragDropEnabled?: boolean;
};

export const MenuItems = ({
	navigationContainer,
	dragDropEnabled,
}: MenuItemsProps): React.JSX.Element => {
	const containerId = useContainerId();
	const [views] = useNavigationViews({ containerId });
	return (
		<Views
			navigationContainer={navigationContainer}
			views={views}
			dragDropEnabled={dragDropEnabled}
		/>
	);
};
